<template>
  <div class="d-flex align-items-center justify-content-between mb-3 px-4">
    <h5 class="font-size-16 m-0">
      {{ $t(`${tt}.title`) }}
    </h5>
    <div class="btn-group">
      <button
        v-for="id of list"
        :key="id"
        type="button"
        class="btn btn-light btn-sm"
        :class="{active: value === id}"
        @click="value = id"
      >
        {{ $t(`${tt}.${id}`) }}
      </button>
    </div>
  </div>
</template>

<script>
import {ChatStatusChat, ChatStatusNew, ChatStatusResolved} from "../../../services/chat/const";

export default {
  data: () => ({
    tt: 'rooms.select_status',
    list: [
      'all',
      ChatStatusNew,
      ChatStatusChat,
      ChatStatusResolved,
    ],
  }),
  computed: {
    value: {
      get() {
        return this.$store.state.rooms.fetchFilter.status
      },
      set(id) {
        this.$store.commit('rooms/SET_FILTER_STATUS', id);
      },
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
